import React, {useContext, useEffect, useState} from 'react'
import {TouchableOpacity, View} from 'react-native'
import styles from './credit-limit-styles'
import { useDispatch, useSelector } from 'react-redux'
import { getCreditLimitFromApi } from '../../actions/creditLimitActions'
import PtActivityIndicator from "../core/pt-activity-indicator/pt-activity-indicator";
import PtText from "../core/pt-text/pt-text";
import PtCallout from "../core/pt-callout/pt-callout";
import { getTranslation } from "../../helpers/getTranslation";
import UserContext from "../../helpers/UserContext";


/** moved translating labels outside main function to reduce its cognitive complexity */
const getLabels = (props:any) => {
  return {
    creditLimitTitle : props.title || getTranslation('credit.limit.title') || 'Credit limit',
    totalCreditLimitLabel : props.creditLimitLabel || getTranslation('total.credit.limit.label') || 'Total credit limit',
    usedCreditLimitLabel : props.usedCreditLimitLabel || getTranslation('used.credit.limit.label') || 'Used credit limit',
    availableCreditLimitLabel : props.availableCreditLimitLabel || getTranslation('available.credi.limit.label') || 'Available credit limit',
    showDetailsLabel : props.showDetailsLabel || getTranslation('credit.limit.show.details.label') || 'Show details',
    hideDetailsLabel : props.hideDetailsLabel || getTranslation('credit.limit.hide.details.label') || 'Hide details',
    noAuthText: props.noAuthText || getTranslation('credit.limit.no.auth.text') || 'You are not logged in. Feature not available',
  }
};


export default function CreditLimit(props:any) {

  const {userData, updateUserData} = useContext(UserContext);

  const impersonationOK = !userData.mustImpersonate || (userData.mustImpersonate && userData.impersonatingId !== null);

  /** labels (translations)*/
  const labels = getLabels(props);

  const PTBaseSiteUID = props.baseSiteUID || userData.baseSiteUID;
  const PTSalesAreaDependantCustomerUid = props.salesAreaDependantCustomerUid || userData.salesAreaDependantCustomerUid;

  const showTitle = props.showTitle || false;

  const isAuthenticated: any = useSelector((state: any) => state.authReducer.isAuthenticated);
  const creditLimit: any = useSelector((state: any) => state.creditLimitReducer.creditLimit);
  const loading: any = useSelector((state: any) => state.creditLimitReducer.loading);
  const errorMessage: string = useSelector((state: any) => state.creditLimitReducer.errorMessage);
  const dataCollected: boolean = useSelector((state:any) => state.creditLimitReducer.dataCollected);

  const dispatch = useDispatch();

  useEffect(() => {
    if (isAuthenticated && impersonationOK && !dataCollected) {
      getCreditLimitFromApi(dispatch, PTBaseSiteUID, PTSalesAreaDependantCustomerUid)
    }
  }, [isAuthenticated, impersonationOK, dataCollected]);

  const [detailsVisible, setDetailsVisible] = useState(false);

  const toggleDetailsVisible = () => {
    setDetailsVisible(!detailsVisible);
  };

  const getCreditLimitRow = (title: string, value: string) => {
    return (
      <View style={styles.creditLimitRow}>
        <PtText style={styles.creditLimitTitle}>{title}:</PtText>
        <PtText>{value}</PtText>
      </View>
    )
  };

  const getToggleHeaderRow = (title: string, value: string, blocked:boolean) => {
    return (
      <View style={styles.toggleHeader}>
        <PtText style={[styles.availableCreditLimitValue, blocked ? styles.blockedValue : '']}>{value}</PtText>
        <PtText>
          {detailsVisible ?
            <PtText style={styles.containerToggleText}>{labels.hideDetailsLabel}</PtText>
            :
            <PtText style={styles.containerToggleText}>{labels.showDetailsLabel}</PtText>
          }
        </PtText>
      </View>
    )
  };

  const disabledTitleStyle = isAuthenticated ? null : styles.titleDisabled;

  return (
    <View>
      <PtActivityIndicator show={loading} />
      {showTitle ?
        <PtText style={[styles.title, disabledTitleStyle]}>{labels.creditLimitTitle}</PtText>
        : null
      }
      {isAuthenticated ?
        !loading && !errorMessage ?
          <View style={styles.creditLimitContainer}>
            <View style={styles.toggleHeaderContainer}>
              <TouchableOpacity onPress={() => toggleDetailsVisible()}>
                {getToggleHeaderRow(labels.availableCreditLimitLabel, creditLimit.availableCreditLimit, creditLimit.creditBlocked)}
              </TouchableOpacity>
            </View>
            {detailsVisible ?
              <View style={styles.toggleDetailsContainer}>
                <View style={styles.toggleDetailsContent}>
                  {getCreditLimitRow(labels.totalCreditLimitLabel, creditLimit.creditLimit)}
                  {getCreditLimitRow(labels.usedCreditLimitLabel, creditLimit.usedCreditLimit)}
                </View>
              </View>
              : null
            }

          </View>
          :
          errorMessage ?
            <PtCallout type={`error`} message={errorMessage} />
            : null
        :
        <PtText style={styles.noAuthText}>{labels.noAuthText}</PtText>
      }
    </View>
  )
}
